import { Sparkles } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { DEFAULT_PROJECT_ID } from '@/lib/navTree';

export const isShowcase = (id) => id === DEFAULT_PROJECT_ID;

export const ShowcaseBadge = () => (
  <span className="inline-flex items-center rounded-full bg-amber-100 text-amber-900 border border-amber-300 px-2 py-0.5 text-[10px] font-semibold" data-testid="showcase-badge">
    Showcase project
  </span>
);

// Shown to anyone who is not a TEN BKC member: this page is FBC's example, not their project.
export const ShowcaseNotice = ({ onFindProject }) => (
  <div className="rounded-xl border border-amber-300 bg-amber-50 dark:bg-amber-900/20 p-3 sm:p-4 mb-4 flex flex-col sm:flex-row sm:items-center gap-3" data-testid="showcase-notice">
    <Sparkles className="h-5 w-5 text-amber-700 shrink-0" />
    <p className="text-sm flex-1">
      <b>Showcase project.</b> TEN BKC is FBC's example of how any project looks and works on FBC. Look around, then find your own project or ask us to add it.
    </p>
    <Button size="sm" onClick={onFindProject} className="shrink-0" data-testid="showcase-find-project">Find my project</Button>
  </div>
);
